import React from 'react'
import { formatPrice } from '@@partner:helpers/util'

import { Message, Content } from 'rsuite'

export interface OrderMinCostInfoProps {
  cost: number
  minCost: number
}
export default function OrderMinCostInfo ({
  minCost,
  cost
}: OrderMinCostInfoProps) {
  const diff = minCost - cost

  return (
    <div className="OrderMinCostInfo" style={{ margin: '1em auto' }}>
      {diff > 0 && (
        <Message
          showIcon
          type="error"
          header={`Минимальный заказ ${formatPrice(minCost)}`}
        >
          <Content>
            Доберите товары на сумму <strong>{formatPrice(diff)}</strong>
          </Content>
        </Message>
      )}
    </div>
  )
}
